import { render, staticRenderFns } from "./ServiceTreeItem.vue?vue&type=template&id=be82db7a&scoped=true"
import script from "./ServiceTreeItem.vue?vue&type=script&lang=js"
export * from "./ServiceTreeItem.vue?vue&type=script&lang=js"
import style0 from "./ServiceTreeItem.vue?vue&type=style&index=0&id=be82db7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be82db7a",
  null
  
)

export default component.exports